import { FC } from 'react';
import { PlusOutlined, DownOutlined } from '@ant-design/icons';
import { ProButton, ProDropdown } from '../antd';
import { BaseOperationButtonGroupProps } from './interface';

/** 新增按钮组 */
const AddButtonGroup: FC<BaseOperationButtonGroupProps> = props => {
  const { children, groupText, ...restProps } = props;
  return (
    <ProDropdown trigger={['click']} {...restProps}>
      {children || (
        <ProButton icon={<PlusOutlined />} type="primary">
          {groupText}
          <DownOutlined />
        </ProButton>
      )}
    </ProDropdown>
  );
};

AddButtonGroup.defaultProps = {
  groupText: '新增',
};

export default AddButtonGroup;
